module.exports = __webpack_public_path__ + "img/video-1.d8d359e8.png";